module.exports = __webpack_public_path__ + "static/media/favourable_situation.f29d2fb7.svg";